var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCloseLot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "31px",
    viewBox: "0 0 36 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5DE5808B-ED8E-4265-99F9-89912B9CADA2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-884.000000, -1069.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "closelog",
    transform: "translate(885.000000, 1070.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-lot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paka",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-56",
    points: "0.6 8.84140625 8.41176758 0.9 17.2364746 0.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-56",
    transform: "translate(20.118237, 4.870703) scale(-1, 1) translate(-20.118237, -4.870703) ",
    points: "11.8 8.84140625 19.6117676 0.9 28.4364746 0.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7319336,1 L14.7319336,8.39160156",
    id: "Path-57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(21.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,6 L13,6 C13.5522847,6 14,6.44771525 14,7 L14,16 C14,16.5522847 13.5522847,17 13,17 L1,17 C0.44771525,17 6.76353751e-17,16.5522847 0,16 L0,7 C-6.76353751e-17,6.44771525 0.44771525,6 1,6 Z M6.7,11.9146471 L6.7,13.5 C6.7,13.7761424 6.92385763,14 7.2,14 C7.47614237,14 7.7,13.7761424 7.7,13.5 L7.7,11.9146471 C8.28259619,11.7087289 8.7,11.1531094 8.7,10.5 C8.7,9.67157288 8.02842712,9 7.2,9 C6.37157288,9 5.7,9.67157288 5.7,10.5 C5.7,11.1531094 6.11740381,11.7087289 6.7,11.9146471 Z",
    id: "Combined-Shape",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,4.22375176 L11,4.16437676 L11,4 C11,2.34314575 9.65685425,1 8,1 L6,1 C4.34314575,1 3,2.34314575 3,4 L3,4.22375176 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-85",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "28.2 11.1729167 28.2 9.23177083 0.86735026 9.23177083 0.86735026 23.002832 18.1526693 23.002832"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCloseLot);
export default __webpack_public_path__ + "static/media/ico_close-lot.0f9258ecf07103ac7ca5c7d8b8e4c39b.svg";
export { ForwardRef as ReactComponent };